import { format } from '@bilibili-maoer/web-utils'

import { Seconds } from '~/shared/types/base/units'

export const formatContractTime = (seconds: Seconds) => format.formatUTCTimeBySeconds(seconds, 'YYYY-MM-DD HH:mm')
